import React from 'react';
import { createRoot } from 'react-dom/client';
import CurrencySwitcher from './components/CurrencySwitcher';
import VpsList from './components/VpsList';
import DedicatedList from './components/DedicatedList';
import OtherList from './components/OtherList';

// Import CSS for standard Webpack loaders
import '../assets/css/osp-frontend.css';

const initFrontend = () => {
  const mountPoints = document.querySelectorAll('.osp-react-app');
  mountPoints.forEach(el => {
    const appType = el.getAttribute('data-app');
    const root = createRoot(el);

    if (appType === 'currency-switcher') {
      const traceIp = el.getAttribute('data-trace-ip') || '';
      root.render(<CurrencySwitcher traceIp={traceIp} />);
    } else if (appType === 'vps') {
      const type = el.getAttribute('data-type') || '';
      const category = el.getAttribute('data-category') || '';
      const searchEnabled = el.getAttribute('data-search-enabled') !== 'false';
      const buttonText = el.getAttribute('data-button-text') || 'Configure';
      const layout = el.getAttribute('data-layout') || 'table';
      let plans = [];
      try {
        plans = JSON.parse(el.getAttribute('data-plans') || '[]');
      } catch (e) {
        console.error('Failed to parse VPS plans', e);
      }
      let currencyInfo = null;
      try {
        currencyInfo = JSON.parse(el.getAttribute('data-currency-info') || 'null');
      } catch (e) {
        console.error('Failed to parse VPS currencyInfo', e);
      }
      root.render(
        <VpsList
          type={type}
          category={category}
          searchEnabled={searchEnabled}
          buttonText={buttonText}
          layout={layout}
          initialPlans={plans}
          initialCurrencyInfo={currencyInfo}
        />
      );
    } else if (appType === 'dedicated') {
      const type = el.getAttribute('data-type') || '';
      const category = el.getAttribute('data-category') || '';
      const search = el.getAttribute('data-search') || '';
      const name = el.getAttribute('data-name') || '';
      const processor = el.getAttribute('data-processor') || '';
      const ram = el.getAttribute('data-ram') || '';
      const harddisk = el.getAttribute('data-harddisk') || '';
      const bandwidth = el.getAttribute('data-bandwidth') || '';
      const ip = el.getAttribute('data-ip') || '';
      const location = el.getAttribute('data-location') || '';
      const price = el.getAttribute('data-price') || '';
      const buttonText = el.getAttribute('data-button-text') || 'Configure';
      const layout = el.getAttribute('data-layout') || 'table';
      const pagination = el.getAttribute('data-pagination') === 'true';
      const searchEnabled = el.getAttribute('data-search-enabled') !== 'false';
      let plans = [];
      try {
        plans = JSON.parse(el.getAttribute('data-plans') || '[]');
      } catch (e) {
        console.error('Failed to parse Dedicated plans', e);
      }
      let currencyInfo = null;
      try {
        currencyInfo = JSON.parse(el.getAttribute('data-currency-info') || 'null');
      } catch (e) {
        console.error('Failed to parse Dedicated currencyInfo', e);
      }

      root.render(
        <DedicatedList
          type={type}
          category={category}
          search={search}
          name={name}
          processor={processor}
          ram={ram}
          harddisk={harddisk}
          bandwidth={bandwidth}
          ip={ip}
          location={location}
          price={price}
          buttonText={buttonText}
          layout={layout}
          pagination={pagination}
          searchEnabled={searchEnabled}
          initialPlans={plans}
          initialCurrencyInfo={currencyInfo}
        />
      );
    } else if (appType === 'other') {
      const gid = el.getAttribute('data-gid') || '';
      const filter = el.getAttribute('data-filter') || '';
      let plans = [];
      try {
        plans = JSON.parse(el.getAttribute('data-plans') || '[]');
      } catch (e) {
        console.error('Failed to parse other plans', e);
      }
      let currencyInfo = null;
      try {
        currencyInfo = JSON.parse(el.getAttribute('data-currency-info') || 'null');
      } catch (e) {
        console.error('Failed to parse other currencyInfo', e);
      }
      root.render(
        <OtherList
          gid={gid}
          filter={filter}
          initialPlans={plans}
          initialCurrencyInfo={currencyInfo}
        />
      );
    }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFrontend);
} else {
  initFrontend();
}
